const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export const createStroke = ({ point, size, hardness, opacity }) => ({
  id: `stroke-${Date.now()}-${Math.floor(Math.random() * 100000)}`,
  points: [point],
  size,
  hardness,
  opacity,
  composite: 'destination-out',
});

export const addPointToStroke = (stroke, point) => {
  const last = stroke.points[stroke.points.length - 1];
  if (!last || Math.hypot(point.x - last.x, point.y - last.y) > 0.002) {
    stroke.points.push(point);
  }
};

export const getNormalizedPointFromBounds = (event, bounds) => ({
  x: clamp((event.clientX - bounds.left) / bounds.width, 0, 1),
  y: clamp((event.clientY - bounds.top) / bounds.height, 0, 1),
});
